import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import MessageSound from 'assets/message.mp3';
import {
  SetNotificationPayload,
  ConversationType,
  SetCollapsePayload,
} from './types';

const initialState = {
  jwtToken: null as string,
  notificationSettings: {
    [ConversationType.ANNOUNCEMENT]: true,
    [ConversationType.PRIVATE]: true,
    [ConversationType.GROUP]: true,
    [ConversationType.PUBLIC]: true,
  } as Record<ConversationType, boolean>,
  collapseStates: {
    [ConversationType.ANNOUNCEMENT]: true,
    [ConversationType.PRIVATE]: true,
    [ConversationType.GROUP]: true,
    [ConversationType.PUBLIC]: true,
  } as Record<ConversationType, boolean>,
  fullscreen: false,
};

export { initialState as twilioPreloadInitialState };

export type TwilioPreloadSliceType = typeof initialState;

export const twilioPreloadSlice = createSlice({
  name: 'twilioPreload',
  initialState,
  reducers: {
    setJwtToken(state, action: PayloadAction<string>) {
      state.jwtToken = action.payload;
    },
    setNotificationSetting(state, action: PayloadAction<SetNotificationPayload>) {
      const { settingTarget, switchValue } = action.payload;
      state.notificationSettings[settingTarget] = switchValue;
    },
    playNotificationSound(state, action: PayloadAction<ConversationType>) {
      const soundEnabled = state.notificationSettings[action.payload];
      if (soundEnabled) new Audio(MessageSound)?.play()?.catch((e) => console.warn(e.message));
    },
    setCollapseState(state, action: PayloadAction<SetCollapsePayload>) {
      const { type, value } = action.payload;
      state.collapseStates[type] = value;
    },
    setFullscreen(state, action: PayloadAction<boolean>) {
      state.fullscreen = action.payload;
    },
  },
});

export const {
  setJwtToken,
  setNotificationSetting,
  playNotificationSound,
  setCollapseState,
  setFullscreen,
} = twilioPreloadSlice.actions;

export const preloadReducer = twilioPreloadSlice.reducer;
